function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled336X336Px = function SvgFilled336X336Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 336 336",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M194.2 12 328 151.3c11.5 11.9 10.9 30.8-1.2 42.1L185.1 325c-12.1 11.3-31.3 10.7-42.8-1.2L8.5 184.5c-11.5-12-10.9-30.8 1.2-42.1L151.4 10.8C163.5-.5 182.7 0 194.2 12",
    style: {
      fill: "#e2001a"
    }
  }));
};
export default SvgFilled336X336Px;